/**
 * The public configuration, as `apps/web/vite.config.ts` compiled it in. Only
 * the names on the allow-list in `apps/web/env.public.ts` exist here; the
 * secret key, the database password and the driver credentials never reach
 * the browser.
 */
export interface PublicConfig {
  appEnv: string
  supabaseUrl: string
  supabaseProjectRef: string
  supabasePublishableKey: string
}

type DefinedEnv = Record<string, string | undefined>

export function readPublicConfig(env: DefinedEnv = import.meta.env as unknown as DefinedEnv): PublicConfig {
  return {
    appEnv: env.APP_ENV ?? '',
    supabaseUrl: env.SUPABASE_URL ?? '',
    supabaseProjectRef: env.SUPABASE_PROJECT_REF ?? '',
    supabasePublishableKey: env.SUPABASE_PUBLISHABLE_KEY ?? '',
  }
}

/** Deploying to production is forbidden for this run and for every stage in
 *  it. The page refuses to treat itself as production rather than guessing. */
export function isProduction(config: PublicConfig): boolean {
  return config.appEnv === 'production'
}
